import { render, staticRenderFns } from "./DashboardMessagesCard.vue?vue&type=template&id=14c6d68a&"
import script from "./DashboardMessagesCard.vue?vue&type=script&lang=js&"
export * from "./DashboardMessagesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports